export class AppPermissionConsts {
    static readonly GroupName = 'CareerCompetencies';
    static readonly ConfigurationDefault = this.GroupName + '.Configuration';

    static readonly RolePlaceDefault = this.GroupName + '.RolePlace';
    static readonly RolePlaceUpdate = this.RolePlaceDefault + '.Update';

    static readonly InformationSourceDefault = this.GroupName + '.InformationSource';
    static readonly InformationSourceCreate = this.InformationSourceDefault + '.Create';
    static readonly InformationSourceUpdate = this.InformationSourceDefault + '.Update';
    static readonly InformationSourceDelete = this.InformationSourceDefault + '.Delete';

    static readonly PlaceDefault = this.GroupName + '.Place';
    static readonly PlaceCreate = this.PlaceDefault + '.Create';
    static readonly PlaceUpdate = this.PlaceDefault + '.Update';
    static readonly PlaceDelete = this.PlaceDefault + '.Delete';

    static readonly ShiftDefault = this.GroupName + '.Shift';
    static readonly ShiftCreate = this.ShiftDefault + '.Create';
    static readonly ShiftUpdate = this.ShiftDefault + '.Update';
    static readonly ShiftDelete = this.ShiftDefault + '.Delete';

    static readonly AnswerGroupDefault = this.GroupName + '.AnswerGroup';
    static readonly AnswerGroupCreate = this.AnswerGroupDefault + '.Create';
    static readonly AnswerGroupUpdate = this.AnswerGroupDefault + '.Update';
    static readonly AnswerGroupDelete = this.AnswerGroupDefault + '.Delete';

    static readonly QuestionGroupDefault = this.GroupName + '.QuestionGroup';
    static readonly QuestionGroupCreate = this.QuestionGroupDefault + '.Create';
    static readonly QuestionGroupUpdate = this.QuestionGroupDefault + '.Update';
    static readonly QuestionGroupDelete = this.QuestionGroupDefault + '.Delete';

    static readonly QuestionDefault = this.GroupName + '.Question';
    static readonly QuestionCreate = this.QuestionDefault + '.Create';
    static readonly QuestionUpdate = this.QuestionDefault + '.Update';
    static readonly QuestionDelete = this.QuestionDefault + '.Delete';

    static readonly OperatorDefault =  this.GroupName + '.Operator';
    static readonly OperatorCreate = this.OperatorDefault + '.Create';
    static readonly OperatorUpdate = this.OperatorDefault + '.Update';

    static readonly TemplateDefault =  this.GroupName + '.Template';
    static readonly TemplateCreate = this.TemplateDefault + '.Create';
    static readonly TemplateUpdate = this.TemplateDefault + '.Update';
    static readonly TemplateDelete = this.TemplateDefault + '.Delete';
    static readonly TemplateCopy = this.TemplateDefault + '.Copy';

    static readonly EvaluationDefault =  this.GroupName + '.Evaluation';
    static readonly AutoevaluationDefault = this.EvaluationDefault + '.Autoevaluation';
    static readonly IsOperatorDefault = this.EvaluationDefault + '.IsOperator';
    static readonly EvaluatorDefault = this.EvaluationDefault + '.Evaluator';
    static readonly EvaluationExport = this.EvaluationDefault + '.Export';
    static readonly EvaluationListVisualization = this.EvaluationDefault + '.ListVisualization';

    static readonly CalibrationDefault = this.GroupName + '.Calibration';
    static readonly CalibratorDefault = this.CalibrationDefault + '.Calibrator';

    static readonly ReportDefault = this.GroupName + '.Report';
    static readonly ExportReportResultDefault = this.ReportDefault + '.ExportReportResult';
    static readonly ExportSelfEvaluationReportResultDefault = this.ReportDefault + '.ExportSelfEvaluationReportResult';

    static readonly OperatorEvaluationSummaryDefault =  this.GroupName + '.OperatorEvaluationSummary';
}
